import './syncManagement.css'

import {
	IonButton,
} from '@ionic/react'
import React, { useState } from 'react'

import { compareFixtureOrder } from './fixtureSync'

export type SyncManagementItem = {
	key: string
	date: number
	round: string
	label: string
	actionLabel: string
	onAction?: () => void | Promise<void>
}

function sortSyncManagementItems(items: SyncManagementItem[]) {
	return [...items].sort(compareFixtureOrder)
}

// Show games the user has excluded from Fixture Sync. This lives outside the
// fixture-change modal so skipped/locked games can always be unskipped, even
// when there are no new official changes to prompt the modal.
export function SyncManagement(props: {
	items: SyncManagementItem[]
	initialExpanded?: boolean
}) {
	const { items, initialExpanded = false } = props
	const [ managementExpanded, setManagementExpanded ] = useState(initialExpanded)

	if (!items.length) {
		return null
	}

	const sortedItems = sortSyncManagementItems(items)

	return (
		<div className="sync-management">
			<button
				className="sync-management-toggle"
				onClick={() => setManagementExpanded(prev => !prev)}
			>
				{items.length} skipped game{items.length === 1 ? '' : 's'}...
			</button>
			{managementExpanded && (
				<div className="sync-management-content">
					{sortedItems.map(({ key, label, onAction, actionLabel }) => (
						<div key={key} className="sync-management-item">
							<span>{label}</span>
							{onAction && (
								<IonButton fill="clear" size="small" onClick={() => void onAction()}>
									{actionLabel}
								</IonButton>
							)}
						</div>
					))}
				</div>
			)}
		</div>
	)
}
